












import { Component, Vue, Prop } from 'vue-property-decorator';
import VideoContainer from './VideoContainer.vue'
import { queryLiveRoomDetailById, getToken, getUserSig, entryLiveRoom } from 'apiUtils/ZnPlayer'
import { getWxSign } from 'apiUtils/common'
import { isTest, isPC, isWX, isAndroid, getAppData, isIOS, SDK_PLATFORM } from 'utils/index'
import TimInstance from 'utils/imbase/index'
import TIM from 'tim-js-sdk';
import moment from 'moment'
import { liveStatusEnum, userActionEnum, userActionMsgParam, liveStatusName, streamTypeEnum, streamStatus } from '@/common/enums'
import { msgTypeEnum } from '@/store/types'
import { NO_ACCESS, statusEnum } from './consts'
import { parseToken, MD5 } from '@/sdk/lib'
import { IVideoSource, IAnchors } from './types'
import { checkQNCMD, entryLiveRoomQiNiu } from 'utils/znplay-qiniu-stream'
@Component({
  components: {
    VideoContainer
  },
})
export default class ZnPlayer extends Vue {
  @Prop() private roomId!: string;

  @Prop() private sid!: string;
  @Prop() private userId!: string;
  @Prop() private userName!: string;
  @Prop() private userImg!: string;
  @Prop() private needAuth!: string;

  private liveMessageTitle = ''
  private liveMessageContent = ''
  private liveMessageShow = false
  private liveStatus!: string
  private roomPic = ''
  private isPlaying = false
  private showDialog = false
  private diagoTitle = '提示：'
  private diagoContent = ''
  private timer: any
  private isInitIm = false
  private videoSource?: IVideoSource[] = []
  private anchors: IAnchors[] = []
  private actionParamSeqs = ''
  private masterId = ''
  private stepOut = false
  private loading = false
  private sdkPlatform =  ''
  private hlsPlayUrl =  ''
  private mixLive =  true
  private mounted() {
    this.getRoomInfo();
  }

  private onGroupSystemNoticeReceived (event) {
    const type = event.data.type;
    const message = event.data.message;
    if (type === TIM.TYPES.GRP_TIP_MBR_CANCELED_ADMIN) {
      this.liveMessageShow = true
      this.liveMessageTitle = '直播已结束'
      this.liveMessageContent = this.getSpecTime(Date.now())
    }
  }

  private get getLiveMessageShow () {
    return this.liveMessageShow
  }

  private async initIm() {
    const res: any = await getUserSig(this.roomId, this.userId, this.sid);
    const appdata = getAppData()
    if (res.code === 0) {
      TimInstance.login(this.roomId, {
        identifier: this.userId,
        identifierNick:  this.userName || '游客',
        userSig: res.body.userSig,
        headurl: this.userImg
      });
      TimInstance.onMessageReceived(this.addMes)
      TimInstance.tim.on(TIM.EVENT.GROUP_SYSTEM_NOTICE_RECEIVED, this. onGroupSystemNoticeReceived);
    }
  }


  private addMes(msgList: any[]) {
    msgList.forEach((msg: any) => {
      if (!msg.payload.data) {
        return
      }
      const data: any = JSON.parse(msg.payload.data);
      const userAction = parseInt(data.userAction, 10)
      if (userAction === userActionEnum.UPDATE_LIVEROOM_INFO) {
        const { giftCount, goods: upCount, members: nowPerson, personTotal} = data
        this.$store.dispatch('updateLiveRoomInfo', { giftCount, upCount, nowPerson, personTotal })
        return
      }
      if (+this.sdkPlatform >= SDK_PLATFORM.QI_NIU) {
        if (checkQNCMD(data, this)) return
      } else {
        if (data.cmd === streamStatus.MIX_REFRESH) {
          this.videoSource = [{
            sid: '1',
            refreshTime: Date.now(),
            src: data.url,
            videoType: 'main',
            isPCStream: false
          }]
          return
        }
        if (data.cmd === streamStatus.START) {
          if (this.anchors.some((item) => {
            const flag = item.userId === data.uid && (!this.videoSource || this.videoSource!.length === 0)
            if (flag) {
              this.$store.dispatch('updateCurrentAuthor', item)
              this.masterId =  data.uid
            }
            return flag
          })) {
            setTimeout(() => {
              this.liveMessageShow = false
              this.videoSource = [this.formdataVideoSource(data,  'main')]
            }, 30000)
          }
          return
        }
        if (data.cmd === streamStatus.SHUT) {
          if (data.uid === this.masterId && this.videoSource![0].sid === data.sid) {
            this.liveMessageShow = true
            this.liveMessageContent = '主播暂时离开'
            this.videoSource = []
            this.stepOut = true;
            return
          }
        }
      }
      if (userAction === userActionEnum.UPDATE_MESSAGE) {
        if (+data.actionParam === userActionMsgParam.ACHOR_NOTICE || +data.actionParam === userActionMsgParam.HELP_ACHOR_NOTICE) {
          setTimeout(() => {
            this.$store.dispatch('getNoticeList', {roomId: this.roomId, sid: this.sid})
          }, 1000)
        }
      }
      if (userAction === userActionEnum.AVIMCMD_GIFT) {
        const giftData = JSON.parse(data.actionParam);
        const message = {
          name: data.NickName,
          message:  `${giftData.giftCount}${giftData.giftUnit}${giftData.giftName}`,
          msgType: msgTypeEnum.GIFT_MSG
        }
        this.$store.dispatch('updateLiveRoomMsg', message)
      }
      // 送礼消息显示控制
      if (userAction === userActionEnum.ADMIN_CONTROLS) {
        if (data.actionParam) {
          const controlsObj = JSON.parse(data.actionParam)
          const { isCommentsSection } = controlsObj
          this.$store.dispatch('updateGiftComments', isCommentsSection)
        }
      }
      if (userAction === userActionEnum.UPDATE_MESSAGE) {
        let msgType = msgTypeEnum.COMMON_MSG as msgTypeEnum
        this.anchors.forEach(item => {
          if (item.anchorId === msg.from) {
            if (+data.userAction === 7 && +data.actionParam === 20) {
              msgType = msgTypeEnum.NOTICE
            } else if (item.anchorId === this.masterId) {
              msgType = msgTypeEnum.IS_AUTHOR_MSG
            } else {
              msgType = msgTypeEnum.HLEP_AUTHOR_MSG
            }
          }
        })
        const message = {
          name: msgType === msgTypeEnum.NOTICE ? '公告' : data.NickName,
          message:  data.Content,
          msgType
        }
        this.$store.dispatch('updateLiveRoomMsg', message)
      }
      if (userAction === userActionEnum.CAR_MSG) {
        const goodData = JSON.parse(data.actionParam)
        setTimeout(() => {
          this.$emit('carAction', goodData)
        }, 1000)
      }
    })
  }

  private beforeDestroy() {
    if (this.timer) clearTimeout(this.timer)
  }

  private getSpecTime(time) {
    const formDate = moment(time).format("YYYY.MM.DD HH:mm")
    return `${this.liveStatus === liveStatusEnum.NOT_START ? "开始时间：" : "结束时间："}${formDate}`
  }

  private checkIsMobile(streamArr, liveMode) {
    let pcMode = [3, 4]
    return pcMode.indexOf(+liveMode) < 0 && streamArr.length > 0 && [streamTypeEnum.PC_CAERMA, streamTypeEnum.PC_SHARE_DES, streamTypeEnum.PC_SHARE_WINDOW, streamTypeEnum.PC_MEDIA].indexOf(streamArr[0].st) < 0
  }

  private async getRoomInfo () {
    const loading = this.$weui.loading('加载中')
    const isPreview = this.$route.query.isPreview === '1'
    const accessToken = this.$route.query.accessToken
    const appId = this.$route.query?.appId || this.$route.query?.appid
    const res: any = await queryLiveRoomDetailById(this.sid, this.roomId, this.needAuth ? 21 : 22, accessToken)
    this.loading = false
    loading.hide()
    if (+res.code !== 0 || !res.body) {
      this.$weui.dialog({
        title: '提示',
        content: res.message,
        buttons: [{
            label: '确定',
            type: 'primary',
            onClick: () => {console.log('确定')}
        }]
      })
      return;
    }
    document.title = res.body.roomName || 'znlive'
     // 产险插件集团的提示
    if (+res.body.h5ShareType === 0 && appId === 'com.pingan.chanxian') {
      this.$weui.dialog({
        title: '提示',
        content: '该直播暂不支持h5观看',
        buttons: [{
            label: '确定',
            type: 'primary',
            onClick: () => {
              console.log('确定')
            }
        }]
      })
      return
    }
    if (+res.body.statCode === 2 && !window.location.hash.includes('/livePatrol')) {
      const { dataSource } = this.$route.query
      this.$weui.dialog({
        title: '提示',
        content: dataSource === '10060001' ? '为保障您拥有更好的直播体验，请您转至好帮手APP观看直播。' : '您没有权限查看该视频',
        buttons: dataSource === '10060001' ? [] : [{
          label: '确定',
          type: 'primary',
          onClick: () => {
            console.log('确定')
          }
        }]
        // buttons: [{
        //     label: '确定',
        //     type: 'primary',
        //     onClick: () => {
        //       console.log('确定')
        //     }
        // }]
      })
      return;
    }
    if (res.body.isIdentity > 0 && !isPreview) {
      this.$weui.dialog({
        title: '提示',
        content: '该直播间已开启监学，请进入知鸟app进行学习',
        buttons: [{
            label: '确定',
            type: 'primary',
            onClick: () => {
              console.log('确定')
            }
        }]
      })
      return;
    }
    const liveMode = res.body.liveMode
    this.liveStatus = res.body.status
    this.roomPic = res.body.roomPic
    this.anchors = res.body.anchors
    this.sdkPlatform = res.body.platform
    if (res.body.status !== 3) {
      this.$store.dispatch('updateLiveRoomInfo', {
        nowPerson: res.body.nowPerson,
        giftCount: res.body.giftCount,
        upCount: res.body.upCount,
        personTotal: res.body.personTotal,
      })
      this.$store.dispatch('setAuthorInfo', res.body.anchors)
    }
    if (this.liveStatus === liveStatusEnum.COMPLETE || this.liveStatus === liveStatusEnum.NOT_START) {
      this.liveMessageShow = true
      this.liveMessageTitle = statusEnum[this.liveStatus]
      this.liveMessageContent = this.getSpecTime(liveStatusEnum.NOT_START ? res.body.startTime : res.body.endTime)
      return
    }
    if (this.liveStatus !== liveStatusEnum.NOT_START && this.liveStatus !== liveStatusEnum.PLAYING) {
      this.liveMessageShow = true
      this.liveMessageTitle = statusEnum[this.liveStatus]
      return;
    }
    this.initIm()
    if (this.liveMessageShow) { this.liveMessageShow = false }
    const bzid =  isTest() ? 4721 : 8038;
    if (+this.sdkPlatform >= SDK_PLATFORM.QI_NIU) {
      // 如果mixStream === 1则肯定有混流
      this.mixLive = +res.body.mixStream === 1
      await entryLiveRoomQiNiu({ roomId: this.roomId, sid: this.sid, liveMode}, this)
    } else {
      const tokenRes: any = await getToken({
        sid: this.sid,
        roomId: this.roomId,
      })
      const token = parseToken(tokenRes.body.token);
      const liveRoomRes: any = await entryLiveRoom(token, this.roomId)
      const { pullStreams = [], masterId, mixUrl} = liveRoomRes.data;
      this.masterId = masterId
      let videoSource: IVideoSource[] = []
      if (mixUrl) {
        this.videoSource = [{
          refreshTime: Date.now(),
          sid: '1',
          src: mixUrl,
          videoType: 'main',
          isPCStream: !this.checkIsMobile(pullStreams, liveMode)
        }]
      } else if (pullStreams.length > 0) {
        // 移动端一次支持一路流播放
        this.videoSource = [this.formdataVideoSource(pullStreams.filter((stream, index) => {
          return masterId === stream.uid
        })[0], 'main')]
      } else {
          this.liveMessageShow = true
          this.liveMessageContent = '主播暂时离开'
      }
    }
    // this.$store.dispatch('updateLiveRoomInfo', {
    //   nowPerson: res.body.nowPerson,
    //   giftCount: res.body.giftCount,
    //   upCount: res.body.upCount,
    //   personTotal: res.body.personTotal,
    // })
    // this.$store.dispatch('setAuthorInfo', res.body.anchors)
    this.$store.dispatch('getAuthorDetail')
    this.$store.dispatch('updateSensitiveWord', {liveRoomInfo: res.body})
    this.$store.dispatch('updateGiftComments', res.body.isCommentsSection)
  }


  private formdataVideoSource (stream: any, videoType: string) {
    return {
      sid: stream.sid,
      refreshTime: Date.now(),
      src: `https://hls-${stream.dn}/${stream.can}/${stream.sn}.m3u8`,
      videoType,
      isPCStream: videoType === 'main' && stream.st === streamTypeEnum.PC_CAERMA
    }
  }
}
